export default __webpack_public_path__ + "static/media/exercise.8067057a.svg";